/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolHardWrenchIcon24Solid = forwardRef('ToolHardWrenchIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.03 8.65a1.313 1.313 0 0 1 0-1.856l3.183-3.184c.487-.487.341-1.308-.328-1.471a6.774 6.774 0 0 0-7.93 9.016l-6.169 6.168a2.753 2.753 0 1 0 3.894 3.894l6.17-6.17a6.774 6.774 0 0 0 9.012-7.924c-.162-.671-.983-.817-1.47-.33L17.21 9.974a1.312 1.312 0 0 1-1.856 0L14.029 8.65Z" })));
});
